// Bootstrap
window.Vue = require('vue');
window.EventBus = new Vue;

import '@babel/polyfill';

//Polyfills
import './polyfills/object-assign';
import './polyfills/array-find';
import './polyfills/pad-start';

// Plugins
import jump from 'jump.js';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScrollTo from 'vue-scrollto';
import LoadScript from 'vue-plugin-load-script';

Vue.use(Vue2TouchEvents);
Vue.use(VueScrollTo);
Vue.use(LoadScript);
import HoverInstent from 'jquery-hoverintent';

// Jquery
if (!window.jQuery) {
    window.jQuery = require('jquery');
}
window.$ = window.jQuery;

// Custom JS solutin
import './helpers/city-selector';

import ModalVideo from 'modal-video'; // Used in B2B pages.

// Mixin
import BreakpointMixins from './components/Mixins/BreakpointMixins';

Vue.mixin(BreakpointMixins);

// Our Components
import GoogleMap from './components/GoogleMap.vue';
import Accordion from './components/Accordion';
import Carousel from './components/Carousel';
import Promotions from './components/Promotions';
import Dropdown from './components/Dropdown';
import CookieBanner from './components/CookieBanner';
import StickyHeader from './components/StickyHeader';
import CityModal from './components/CityModal';
import Hubspot from './components/Hubspot.vue';
import DesignMyNight from './components/DesignMyNight.vue';


Vue.component('google-map', GoogleMap);
Vue.component('designmynight', DesignMyNight);

//Vue.component('eh-modal', CustomModal);

// Create namespace for theme functions
window.BoomBattleBarTheme = window.BoomBattleBarTheme || {};

// Create re-callable Vue init function for CMP compatibility
window.BoomBattleBarTheme.initVueApp = function() {
    // Prevent double initialization
    if (window.BoomBattleBarTheme.vueApp) {
        return;
    }

    // Check if Vue is available
    if (typeof Vue === 'undefined') {
        console.warn('Vue is not loaded yet - ensure Cookiebot script exclusions are configured');
        return;
    }

    // Initialize Vue app
    window.BoomBattleBarTheme.vueApp = new Vue({
        el: '#app',

        created() {
            let body = document.querySelector('body');
            EventBus.$on('ToggleModal', () => {
                body.classList.toggle('app--modal');
            });
            EventBus.$on('ToggleNav', () => {
                body.classList.toggle('app--nav')
            });
            EventBus.$on('TogggleLightbox', () => {
                body.classList.toggle('app--overflow-hidden');
            });
        },

        methods: {
            appClick(event) {
                EventBus.$emit('AppClick', event);
            },

            jumpToDestination(target) {
                jump(target.getAttribute('href'), {
                    duration: 1000,
                    offset: -80,
                })
            }
        },

        components: {
            Accordion,
            Carousel,
            Promotions,
            Dropdown,
            CookieBanner,
            StickyHeader,
            CityModal,
            Hubspot,
        },

        mounted: function () {
            // Setup the video. 
            // @see https://www.npmjs.com/package/modal-video
            new ModalVideo('.js-modal-toggle', {
                channel: 'youtube'
            });
        }
    });
};

// Initialize on DOMContentLoaded or immediately if DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        window.BoomBattleBarTheme.initVueApp();
    }, false);
} else {
    // DOM is already loaded, initialize immediately
    window.BoomBattleBarTheme.initVueApp();
}

// Re-init on Cookiebot consent (if Cookiebot blocked it initially)
window.addEventListener('CookiebotOnAccept', function() {
    window.BoomBattleBarTheme.initVueApp();
    window.BoomBattleBarTheme.reinitAllCarousels();
}, false);

// Function to re-initialize all Vue components that need it
window.BoomBattleBarTheme.reinitAllCarousels = function() {
    setTimeout(function() {
        if (window.BoomBattleBarTheme.vueApp && window.BoomBattleBarTheme.vueApp.$children) {
            function findAndReinitComponents(component) {
                // Reinit Carousel components
                if (component.$options.name === 'Carousel' || component.$options._componentTag === 'carousel') {
                    if (typeof component.initCarousel === 'function') {
                        component.initCarousel();
                    }
                }
                // Reinit StickyHeader components
                if (component.$options.name === 'StickyHeader' || component.$options._componentTag === 'sticky-header') {
                    if (typeof component.initStickyHeader === 'function') {
                        component.initStickyHeader();
                    }
                }
                if (component.$children && component.$children.length) {
                    component.$children.forEach(findAndReinitComponents);
                }
            }
            findAndReinitComponents(window.BoomBattleBarTheme.vueApp);
        }
    }, 100);
};

// Vue initialization wrapper
window.onload = function () {

    // Lazy loading is handled below
};

// Create re-callable DOM handlers function for CMP compatibility
window.BoomBattleBarTheme.initDOMHandlers = function() {
    // Add idempotent flag
    if (window.BoomBattleBarTheme.domHandlersInitialized) {
        return;
    }

    /**
     * Lazy loading
     */
    if (typeof $.fn.lazyload !== 'undefined') {
        $(".lazy").lazyload();
    }

    /**
     * Opening the selected accordions which are set to default to be opened from WP
     */
    $(".page-template-ld-landing .accordion.initiallyOpenedAccordion").addClass('accordion__opened').find('.icon.icon--plus').removeClass('icon--plus').addClass('icon--minus');
    var allAccordions = $('.accordion');
    $('.accordion').on('click', function (ev) {
        var clickedAccordion = $(this);
        if (clickedAccordion.hasClass('accordion__opened')) {
            clickedAccordion.find('.icon.icon--minus').removeClass('icon--minus').addClass('icon--plus');
            clickedAccordion.removeClass('accordion__opened');
            return;
        }
        clickedAccordion.find('.icon.icon--plus').removeClass('icon--plus').addClass('icon--minus');
        if ($(".page-template-ld-landing").length > 0) {
            allAccordions.each(function () {
                var currentAccordion = $(this);
                if (currentAccordion.hasClass('accordion__opened')) {
                    currentAccordion.removeClass('accordion__opened')
                    currentAccordion.find('.icon.icon--minus').removeClass('icon--minus').addClass('icon--plus');
                }
            })
        }
        clickedAccordion.addClass('accordion__opened')
    })

    if (window.innerWidth > 899) {
        $(".section--fullwidth").each(function() {
			var headerHeight = 0;

			// Grab the largest height.
			$(this).find(".card-cta__title").each(function() {
				headerHeight = $(this).outerHeight() > headerHeight
					? $(this).outerHeight()
					: headerHeight;
			});

			// Apply to all headers.
			$(this).find(".card-cta__title").each(function() {
				$(this).css('min-height', headerHeight);
			});
		});
    }

	$('header.site-header').before('<header class="site-header-placeholder"></header>');

	//mega munus items
	if($('.has-icon-submenu').length){
		document.querySelectorAll('.has-icon-submenu .dropdown__menu .container > a ').forEach( ( link ) => {
			if(link.querySelector('.menu-image')) {
				
				if(link.querySelector('.menu-image').parentNode.classList.contains('menu-image-hover-wrapper')) {
					link.querySelector('.menu-image-hover-wrapper').classList.add ('has-hover-image')
				}
				else {
					$(link.querySelector('.menu-image')).wrap('<span class="menu-image-hover-wrapper"></span>')
				}

			}
			else if( ! link.querySelector('.dashicons')) {
				link.innerHTML = '<span class="menu-image-title">' + link.innerHTML + '</span>'
			}
	
		})

		document.querySelectorAll('.has-icon-submenu').forEach( ( item ) => {
			let dropdown = item.querySelector('.dropdown__menu');
			
			item.addEventListener ('mouseover', () => {
				dropdown.style.setProperty("max-height", `${dropdown.scrollHeight}px`);
				dropdown.classList.add('is-opened');
				document.querySelector('body').classList.add('has-submenu-opended');
				if( document.querySelector('body').classList.contains('is-site-header--top') ){
					document.querySelector('.site-header-placeholder').style.setProperty("--custom-height", `${dropdown.scrollHeight}px`)
				}
				document.querySelector('.site-header__banner-wrapper').style.setProperty("--custom-y", `${dropdown.scrollHeight}px`)
			})

			item.addEventListener ('mouseleave', () => {
				document.querySelector('body').classList.remove('has-submenu-opended');
				document.querySelector('.site-header-placeholder').style.setProperty("--custom-height", `0px`);
				document.querySelector('.site-header__banner-wrapper').style.setProperty("--custom-y", `0px`)
				dropdown.style.setProperty("max-height", `0px`)
				dropdown.classList.remove('is-opened');
				// console.log('mouse out', dropdown.scrollHeight)
			})
		});
	}

    window.BoomBattleBarTheme.domHandlersInitialized = true;
};

// Initialize immediately
document.addEventListener('DOMContentLoaded', window.BoomBattleBarTheme.initDOMHandlers, false);

// Re-init on Cookiebot consent
window.addEventListener('CookiebotOnAccept', window.BoomBattleBarTheme.initDOMHandlers, false);

/**
 * JS based on mobile menu dropdown
 *
 * Implement visibility and hidden feature of the mobile submenu
 */
$(document).on( 'click', '.main-menu-link', function(e){     
	if( $(this).closest( "li.main-menu-item" ).hasClass('menu-item-has-children') ) {
		e.preventDefault();
		$(this).siblings('ul').toggleClass('dropdown__item_hidden');
	}
});

/**
 * Location Boilerplate
 * 
 * When a location is selected, redirect to the location page
 */
$(document).on( 'change', '.section-location-boilerplate .package__button', function(e){
    window.location.href = this.value;
});

// Create re-callable video and scroll handlers for CMP compatibility
window.BoomBattleBarTheme.initVideoAndScrollHandlers = function() {
    // Add idempotent flag
    if (window.BoomBattleBarTheme.videoAndScrollHandlersInitialized) {
        return;
    }

    // Delay the loading of the video
    setTimeout(function() {
        var video = document.getElementById("homepage-hero");
        if (!video) return; // Add early return if video element doesn't exist

        var source = video.querySelector('source');
        if (!source) return; // Add early return if source element doesn't exist

        // Set the video source dynamically
        var videoSrc = source.getAttribute('data-src');
        if (videoSrc) {
            source.setAttribute('src', videoSrc);
        }

        // Add video attributes
        video.setAttribute('autoplay', 'autoplay');
        video.setAttribute('muted', 'muted');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', 'loop');

        video.muted = true;

        video.load();
        video.play();
    }, 2000);

    /**
     * Add smooth scroll effect to navigational target of specific section
     * e.g. #christmas
     * 
     * This solves the issue with Gmaps pushing down the content downward
    */
    var get_current_hash = window.location.hash;
    if( get_current_hash ) {
        const hash_target = get_current_hash.slice(1);
        if( document.getElementById( hash_target ) ) {
            setTimeout(function() {
                document.getElementById( hash_target ).scrollIntoView({
                    behavior: 'smooth'
                });
            }, 1000);
        }
    }

    const stickyButton = document.querySelector('.eh-sticky-button');

    // Function to show/hide the button based on scroll
    function handleScroll() {
        const scrollPosition = window.scrollY || window.pageYOffset;
        // Show the button when scrolled down 300px or more
        if (scrollPosition > 300) {
            if( stickyButton ) {
                stickyButton.classList.add('show');
            }
        } else {
            if( stickyButton ) {
                stickyButton.classList.remove('show');
            }
        }
    }

    // Function to check if the screen is mobile-sized
    function isMobile() {
        return window.innerWidth <= 768; // Check if the screen width is 768px or less (mobile)
    }

    window.addEventListener('scroll', function() {
        // Only run the scroll function on mobile screens
        if (isMobile()) {
            handleScroll();
        }
    });

    // Also run the handleScroll function on page load to ensure button visibility is correct
    if (isMobile()) {
        handleScroll();
    }

    // Listen for window resize event to reapply the logic when screen size changes
    window.addEventListener('resize', function() {
        if (!isMobile() && stickyButton) {
            stickyButton.classList.remove('show'); // Hide the button on larger screens
        }
    });

    window.BoomBattleBarTheme.videoAndScrollHandlersInitialized = true;
};

// Initialize immediately
document.addEventListener("DOMContentLoaded", window.BoomBattleBarTheme.initVideoAndScrollHandlers, false);

// Re-init on Cookiebot consent
window.addEventListener('CookiebotOnAccept', window.BoomBattleBarTheme.initVideoAndScrollHandlers, false);

// Dynamically assign z-index to stacked .section.section-location-boilerplate elements
(function() {
  var sections = document.querySelectorAll('section.section-location-boilerplate'); 
  if (sections.length > 0) {
    var baseZIndex = 100; // Lower z-index to stay below header (998) and banner (997)
    sections.forEach(function(section, index) {
      section.style.zIndex = baseZIndex - index;
    });
  }
  
  // Also handle #locations-new specifically if it exists
  var locationsNew = document.getElementById('locations-new');
  if (locationsNew) {
    locationsNew.style.zIndex = 100; // Same as base z-index for location sections
  }
})();




// WEBPACK FOOTER //
// ./assets/js/frontend.js